module.exports = __webpack_public_path__ + "media/images/help/delivery/eyecatch-calendar-express-10-8e52747d98a02e311cacaa7748db67ac.svg";